import { put, takeLatest, select, call, all } from 'redux-saga/effects';
import types from './types';
import actions from './actions';
import ktRequest from '../../../utils/request';

const getCurrentCenterId = state => state.identity.centerId;
const getCenterRequiresPhotoApproval = state => state.gallery.overview.requiresPhotoApproval;

function * getChildGallery (payload) {
  try {
    const { childId } = payload;
    const centerId = yield select(getCurrentCenterId);
    const galleryResponse = yield ktRequest.get(`gallery/center/${centerId}/child/${childId}`, 'gallery');
    const { images } = galleryResponse;

    yield put(actions.getChildGallerySuccess(childId, images));
  } catch (error) {
    yield put(actions.getChildGalleryFailure(error));
  }
}

function * uploadPhotosToGallery (payload) {
  try {
    const { childId, files } = payload;
    const centerId = yield select(getCurrentCenterId);
    const centerRequiresPhotoApproval = yield select(getCenterRequiresPhotoApproval);
    const payloadFiles = yield all(files.map(file => call(formatFile, file)));

    // upload files in parallel
    yield all(payloadFiles.map(file => call(uploadPhoto, [childId, file])));
    yield put(actions.uploadPhotosToChildGallerySuccess());

    // make call to get updates to the child's gallery
    if (!centerRequiresPhotoApproval) {
      yield call(getChildGallery, { childId });
    }

    yield put({ type: 'GET_CENTER_GALLERY_INFORMATION_REQUEST', centerId });
  } catch (error) {
    yield put(actions.uploadPhotosToChildGalleryFailure(error.message));
  }
}

function * uploadPhoto (payload) {
  try {
    const [childId, file] = payload;
    const body = {
      childId,
      files: [file]
    };

    const response = yield ktRequest.post('upload/photo', body, 'gallery');

    if (!response.ok) {
      if (response.status === 413) {
        throw new Error('File is too big');
      }

      throw new Error('Error uploading photo');
    }

    return yield body;
  } catch (error) {
    console.log(error);
    return error;
  }
}

function fileToBase64 (file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

// add bae64 representation to the file object before sending to api
async function formatFile (file) {
  const { name, type } = file;
  // encode selected file to a base64 string so it can be passed in json
  const base64 = await fileToBase64(file);

  return {
    file: encodeURIComponent(base64),
    filename: name,
    fileType: type
  };
}

function * removePhotoFromChildGallery (payload) {
  try {
    const { childId, groupImageId } = payload;
    const centerId = yield select(getCurrentCenterId);
    const body = { centerId, childId, groupImageId };

    const response = yield ktRequest.post(`gallery/child/${childId}/delete`, body, 'gallery');

    if (!response.ok) {
      throw new Error('Error trying to remove photo');
    }

    yield put(actions.removeImageFromChildGallerySuccess(childId, groupImageId));
  } catch (error) {
    console.log(error);
    yield put(actions.removeImageFromChildGalleryFailure(error.message));
  }
}

export const childGallerySagas = [
  takeLatest(types.GET_CHILD_GALLERY_REQUEST, getChildGallery),
  takeLatest(types.UPLOAD_PHOTOS_TO_CHILD_GALLERY_REQUEST, uploadPhotosToGallery),
  takeLatest(types.REMOVE_PHOTO_FROM_CHILD_GALLERY_REQUEST, removePhotoFromChildGallery)
];
